import styled from '@emotion/styled'
import React from 'react'
import { ReactComponent as ZocksLogo } from '../../assets/ZocksLogo.svg'
import { ReactComponent as ZocksLogoFull } from '../../assets/ZocksLogoFull.svg'
import classNames from 'classnames'

interface SidebarHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  isSidebarFixed: boolean
  toggleSidebar: () => void
  collapsed: boolean
}

const StyledSidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  height: 4rem;

  > div {
    width: 100%;
    overflow: hidden;
    height: 4rem;
  }
  .bi {
    font-size: 1.25rem;
  }
`

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isSidebarFixed, toggleSidebar, collapsed, ...rest }) => {
  return (
    <StyledSidebarHeader {...rest}>
      <div className={classNames('d-flex align-items-center', { 'justify-content-center': collapsed, 'justify-content-between': !collapsed })}>
        {collapsed ? <ZocksLogo /> : <ZocksLogoFull />}
        {isSidebarFixed ? (
          <>
            {!collapsed ? (
              <div role='button' className='cursor' onClick={toggleSidebar}>
                <i className='bi bi-layout-sidebar-inset-reverse zocks-text-white'></i>
              </div>
            ) : null}
          </>
        ) : (
          <>
            {!collapsed ? (
              <div role='button' onClick={toggleSidebar}>
                <i className='bi bi-layout-sidebar-reverse zocks-text-white'></i>
              </div>
            ) : null}
          </>
        )}
      </div>
    </StyledSidebarHeader>
  )
}
